import { defer, LoaderFunctionArgs } from 'react-router-dom';

import { QueryClient } from '@tanstack/react-query';

import { isNotDefined, isTokenExpired, retrieveToken } from '@hsp/utilities';

import { createBluebookDashboardQuery } from '@p/a/bluebook/hooks/queries/fetch-bluebook-client.hook';
import { loaderDefaults } from '@p/a/bluebook/utilities/loader-dates/loader-defaults.util';

import { BluebookStatus } from '@t/p/bluebook/components/filter/status.enum';

export const bluebookDashboardLoader = (queryClient: QueryClient) => {
  return ({ params: { startDate, endDate, status }, request }: LoaderFunctionArgs) => {
    const filter = new URL(request.url).searchParams.get('search') ?? undefined;
    let isInactive: boolean | undefined;

    ({ endDate, startDate, status } = loaderDefaults(startDate, endDate, status));

    status = isNotDefined(status) ? BluebookStatus.Active : status;

    if (status === BluebookStatus.Active) {
      isInactive = false;
    }

    if (status === BluebookStatus.Inactive) {
      isInactive = true;
    }

    const query = createBluebookDashboardQuery({
      endDate,
      filter,
      isInactive,
      startDate,
    });
    const { queryKey } = query;

    if (isNotDefined(queryKey)) {
      throw new Error('QueryKey not provided');
    }

    const token = retrieveToken();

    if (isNotDefined(token) || isTokenExpired(token)) {
      return defer({ bluebookDashboard: undefined });
    }

    const bluebookDashboard = queryClient.ensureQueryData(query);

    return defer({ bluebookDashboard });
  };
};
